import { useCallback, useState } from "react";

export const useNavigationGuard = ({
  selectedRows,
  setSelectedRows = () => {},
}) => {
  const [navigationModal, setNavigationModal] = useState(false);
  const [pendingChange, setPendingChange] = useState(null);

  const tabSwitch = useCallback(
    (changeRoom) => {
      if (selectedRows.length === 0) {
        setNavigationModal(false);
        changeRoom();
      } else {
        setNavigationModal(true);
        setPendingChange(() => changeRoom);
      }
    },
    [selectedRows]
  );

  const confirmTabSwitch = useCallback(() => {
    if (pendingChange) {
      pendingChange();
    }
    setSelectedRows([]);
    setNavigationModal(false);
  }, [pendingChange, setSelectedRows]);

  const closeNavigationModal = useCallback(() => {
    setNavigationModal(false);
    setPendingChange(null);
  }, []);

  return {
    navigationModal,
    tabSwitch,
    confirmTabSwitch,
    closeNavigationModal,
  };
};
